import { featureItems } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          为什么数百万吃瓜群众选择网红爆料？四大核心优势告诉你答案
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200 rounded-xl p-6 text-center hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-800 font-heading mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}